import React from 'react'
import Featured from './Featured';
import Promo from './Promo';
import Category from './category';
import Aarrivel from './Aarrivel';
import Seac from './Seac';
import './App.css';
import Popup from './Popup';

function Home() {
  return (
  <>

    <Seac/>
   {/* <Category/> */}
    <Aarrivel/>
    <Promo/>
    {/* <Featured/> */}
    {/* <Popup/> */}
  </>
  )
}

export default Home
